import { render, staticRenderFns } from "./mapDataTable.vue?vue&type=template&id=2ec07b18&"
import script from "./mapDataTable.vue?vue&type=script&lang=js&"
export * from "./mapDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports